import { CheckNameValidate, PhoneValidate, ValueValidate } from "@/src/validation";

export const ValidateContact = (
  firstName: string,
  lastName: string,
  mobile: string,
  description: string
): string => {
  const { isValid: fNValid, message: fnMsg } = CheckNameValidate(
    firstName,
    "نام"
  );
  const { isValid: lsValid, message: lsMsg } = CheckNameValidate(
    lastName,
    "نام خانوادگی"
  );
  const { isValid: isDescription, message: msgDescription } = ValueValidate(
    description,
    20,
    "توضیحات",
    2000
  );
  const { isValid: isPhone, message: msgPhone } = PhoneValidate(mobile);

  if (!fNValid) return fnMsg;
  if (!lsValid) return lsMsg;
  if (!isDescription) return msgDescription;
  if (!isPhone) return msgPhone;
  return "";
};
